import {create} from "zustand";

export interface ChannelMessagingState {
    appDomains: any;
    contextUrl: string;
    rightClickTime: number;
    rightClickStack: any[];
    setAppDomains: (appDomains:any) => void;
    setContextUrl: (contextUrl:string) => void;
    setRightClickTime: (rightClickTime:number) => void;
    setRightClickStack: (stack:any[]) => void;
  }

export const useChannelMessagingStore = create<ChannelMessagingState>((set) => ({
   appDomains: {},
   contextUrl: '',
   rightClickTime: 0,
   rightClickStack: [],
   setContextUrl: (contextUrl) => set(() => ({ contextUrl })),
   setAppDomains: (appDomains) => set(() => ({ appDomains })),
   setRightClickTime: (rightClickTime) => set(() => ({ rightClickTime })),
   setRightClickStack: (stack) => set(() => ({ rightClickStack: stack }))
}));